export const HAKLAI_ANOTHER_QUESTIONS_LABELS = Object.freeze({
  sectionTitle: "שאלות נוספות",
  businessLossOffset: "קיזוז הפסד עסקי",
  capitalLossOffset: "קיזוז הפסד הוני",
  expropriationCredit: "האם יש זיכוי הפקעה",
  yes: "כן",
  no: "לא"
});
